itsoftApp.createModule("videoAutoplayLazy", function () {
    const module = this;
    
    const initVideo = function (videoEl) {
        const videoBlockWrapper = videoEl.querySelector(".js-video-container");
        const videoItem = videoBlockWrapper.querySelector(".js-autoplay-video-block");
        videoPlay(videoItem);
    }

    const videoPlay = function (videoItem) {
        videoItem.play();
    }

    module.initVideo = initVideo;
});